import React, { useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import styled from 'styled-components'

import Table from '../../../../components/Table'
import TableAction from './TableAction'

import {
  setModal,
  setPagination,
  setQueryParams,
} from '../../../../store/actions/ratingActions'

import { convertObjectToUrlParams } from '../../../../utils/stateHelpers'

const RatingQuestionList = ({ fetchRatingQuestionList }) => {
  const { ratingQuestions, pagination, loading, queryParams } = useSelector(
    (state) => state.ratings
  )
  const { id } = useParams()

  const dispatch = useDispatch()

  const url = useMemo(() => {
    if (!queryParams.rating_group_id) {
      return `/rating-questions/paged?${convertObjectToUrlParams(queryParams)}&rating_group_id=${id}`
    }
    return `/rating-questions/paged?${convertObjectToUrlParams(queryParams)}`
  }, [queryParams, id])


  const fetchData = () => {
    fetchRatingQuestionList(url)
  }

  const handlePagination = (option) => {
    dispatch(setPagination(option))
    if ('page' in option) {
      dispatch(setQueryParams({ pageNumber: option.page }))
    }
    if ('pageSize' in option) {
      dispatch(setQueryParams({ pageSize: option.pageSize }))
      dispatch(setQueryParams({ pageNumber: 1 }))
    }
  }

  useEffect(() => {
    fetchData()
  }, [queryParams])

  const columns = useMemo(
    () => [
      {
        Header: 'Action',
        accessor: 'actions',
        disableSortBy: true,
        Cell: ({ value }) => <TableAction value={value} />,
      },
      {
        Header: 'Question',
        accessor: 'question',
      },
      {
        Header: 'Rating Matrix Type',
        accessor: 'rating_matrix_type_name',
      },
    ],
    []
  )

  const tableData = ratingQuestions?.map(
    (item) =>
    ({
      actions: item,
      question: item.question,
      rating_matrix_type_id: item.rating_matrix_type_id,
      rating_matrix_type_name: item.rating_matrix_type_name,
    } || '')
  )

  return (
    <StyledRatingQuestionList>
      <Table
        data={tableData}
        columns={columns}
        loading={loading}
        totalPage={pagination?.ratingQuestion?.pageCount}
        currentPage={pagination?.ratingQuestion?.page}
        pageSize={pagination?.ratingQuestion?.pageSize}
        rowCount={pagination?.ratingQuestion?.rowCount}
        fetchData={fetchData}
        setNewPageSize={(e) => handlePagination({ pageSize: e })}
        setCurrentPage={(e) => handlePagination({ page: e })}
        url={url}
        noData="Rating Question List is empty"
        height="calc(105vh - 16.3rem)"
        onClick={() => dispatch(setModal(''))}
      />
    </StyledRatingQuestionList>
  )
}

export default RatingQuestionList

const StyledRatingQuestionList = styled.div`
  width: 100%;
  height: 100%;
`
